// Bornes du format JRAF v1. Une animation qui les dépasse est REFUSÉE à la
// validation (client et serveur). Elles visent un Short : peu de scènes,
// narration courte, scène verticale 360 × 640.

export const JRAF_LIMITS = {
  /** taille du JSON sérialisé, en octets UTF-8 */
  maxBytes: 200_000,
  maxScenes: 20,
  maxObjects: 150,
  maxStepsPerScene: 60,
  maxParameters: 12,
  maxAssets: 40,
  /** durée des étapes d'une scène (hors temps d'attente d'une question) */
  maxSceneTimelineMs: 90_000,
  /** durée estimée de toute l'animation (étapes + narration) */
  maxTotalMs: 600_000,
  maxNarrationChars: 600,
  maxTitleChars: 120,
  maxTextChars: 300,
  maxTexChars: 300,
  maxPointLabelChars: 20,
  maxExpressionChars: 120,
  maxPathChars: 2_000,
  maxPolygonPoints: 24,
  maxTargets: 30,
  maxGroupDepth: 4,
  maxChoices: 6,
  /** coordonnées et longueurs (nombres ET expressions) : la scène fait 360 × 640 */
  maxCoordinate: 10_000,
  /** valeurs des paramètres (défaut, min, max) */
  maxParameterMagnitude: 1_000_000,
  /** nombres affichés (`value`, `value.set`) et constantes */
  maxValueMagnitude: 1_000_000_000_000,
  /** valeurs testées par paramètre (grille du curseur, échantillonnée au-delà) */
  maxSamplesPerParameter: 21,
  /** au-delà, seuls « tous au min » et « tous au max » sont testés parmi les coins */
  maxParametersForCorners: 6,
  maxStepDurationMs: 20_000,
  maxDelayMs: 30_000,
  maxWordCues: 400,
  /** noms d'un objet dans la narration (`mentions`) */
  maxMentions: 6,
  maxMentionChars: 32,
  /** accroche de la vidéo (`bookends.hook`) */
  maxHookChars: 70,
} as const;

/** Canevas recommandé : vertical 9:16 (Shorts, téléphone). */
export const JRAF_DEFAULT_CANVAS = { width: 360, height: 640 } as const;
